import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';
import _ from 'lodash';

export default class TopMessage extends Component {
  render() {
    const { verificationStatus, forceFormEnable } = this.props;

    if (forceFormEnable) {
      return null;
    }

    if (
      !_.isEmpty(verificationStatus) &&
      (verificationStatus.IsSelected || verificationStatus.IsComplete)
    ) {
      return (
        <Message negative>
          <Message.Content>
            This information cannot be changed because verification has already
            been started.
          </Message.Content>
        </Message>
      );
    }

    //AsOfCounts_Application == 1
    if (!_.isEmpty(verificationStatus) && verificationStatus.Phase === 1) {
      return (
        <Message negative>
          <Message.Content>
            This information cannot be changed because application counts have
            been completed.
          </Message.Content>
        </Message>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/components/TopMessage.js